import { styled } from "@l2r-front/l2r-ui"

export const Logo = styled("img")(({ theme }) => ({
    width: 200,
    marginBottom: theme.spacing(10),
}))